/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Events_Filters_EmbeddingInputs */

const es_billing_events_filters_embedding = /** @type {(inputs: Billing_Events_Filters_EmbeddingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embeddings`)
};

const en_billing_events_filters_embedding = /** @type {(inputs: Billing_Events_Filters_EmbeddingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embeddings`)
};

/**
* | output |
* | --- |
* | "Embeddings" |
*
* @param {Billing_Events_Filters_EmbeddingInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_events_filters_embedding = /** @type {((inputs?: Billing_Events_Filters_EmbeddingInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Events_Filters_EmbeddingInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_events_filters_embedding(inputs)
	return en_billing_events_filters_embedding(inputs)
});
export { billing_events_filters_embedding as "billing.events.filters.embedding" }